export const RESERVATION = 'reservation';
export const BLOCK = 'block';

export default Object.freeze({
  RESERVATION,
  BLOCK
});
